import { render } from "./signupUser.vue?vue&type=template&id=627245f4"
import script from "./signupUser.vue?vue&type=script&lang=js"
export * from "./signupUser.vue?vue&type=script&lang=js"

import "./signupUser.vue?vue&type=style&index=0&id=627245f4&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__